// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$seriesCategoryApiService = {
      series_category_api_url: `${process.env.VUE_APP_AUDIOVISUAL_API_URL}/categories`,
      
      /**
       * 查詢
       * @param {*} param 
       * @returns 
       */
      async query(param = '') {
        const url = `${this.series_category_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      }
    }
  }
}
